<template>
  <a-drawer
    :destroy-on-close="true"
    :title="isUpdate ? '告警规则编辑' : '告警规则创建'"
    :visible="visible"
    :width="800"
    @close="closeDrawer"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item label="名称" prop="name" :wrapper-col="wrapperCol">
        <a-input v-model="form.name" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="严重性" prop="severity" :wrapper-col="wrapperCol">
        <a-select v-model="form.severity" :options="options.severity"></a-select>
      </a-form-model-item>
      <a-form-model-item label="日志类型" prop="logType" :wrapper-col="wrapperCol">
        <a-select
          v-model="form.logType"
          :disabled="isUpdate"
          :options="options.logType"
        ></a-select>
      </a-form-model-item>
      <a-form-model-item prop="search" :wrapper-col="wrapperCol">
        <question-icon
          slot="label"
          title="查询语句"
          description="支持 must/should/must_not"
        ></question-icon>
        <code-mirror v-model="form.search"></code-mirror>
      </a-form-model-item>
      <a-form-model-item label="统计周期" prop="period" :wrapper-col="wrapperCol">
        <a-input v-model="form.period" type="number" :min="1" suffix="分钟"></a-input>
      </a-form-model-item>
      <a-form-model-item label="统计方式" prop="aggregationMethod" :wrapper-col="wrapperCol">
        <a-select v-model="form.aggregationMethod" :options="options.logAggregationMethod"></a-select>
      </a-form-model-item>
      <a-form-model-item label="统计字段" prop="aggregationField" :wrapper-col="wrapperCol">
        <a-input v-model="form.aggregationField" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="判断条件" prop="condition" :wrapper-col="wrapperCol">
        <a-select v-model="form.condition" :options="options.condition"></a-select>
      </a-form-model-item>
      <a-form-model-item label="值" prop="value" :wrapper-col="wrapperCol">
        <a-input v-model="form.value" type="number"></a-input>
      </a-form-model-item>
      <a-form-model-item label="启用状态" prop="active">
        <a-switch v-model="form.active"></a-switch>
      </a-form-model-item>
      <a-form-model-item
        :wrapper-col="{ span: 20, offset: 4 }"
        style="margin-bottom: 0"
      >
        <a-space size="middle">
          <a-button type="primary" @click="ok" :loading="loading">确定</a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  createLogTrigger,
  getLogTrigger,
  updateLogTrigger
} from '@/api/log-trigger'
import {
  alertSeverities,
  compareConditions,
  logAggregationMethods,
  logTypes
} from '@/utils/const'
import CodeMirror from '@/components/CodeMirror.vue'
import QuestionIcon from '@/components/icon/QuestionIcon.vue'

export default {
  name: 'InputDrawer',
  components: {
    CodeMirror,
    QuestionIcon
  },
  data () {
    return {
      visible: false,
      isUpdate: false,
      loading: false,
      wrapperCol: {
        span: 20
      },
      id: '',
      form: {
        name: '',
        severity: undefined,
        search: '',
        period: 1,
        aggregationMethod: undefined,
        aggregationField: '',
        condition: undefined,
        value: '',
        active: true
      },
      rules: {
        name: [{
          message: '请输入告警规则名称',
          required: true,
          trigger: 'blur'
        }],
        severity: [{
          message: '请选择严重性',
          required: true,
          trigger: 'change'
        }],
        logType: [{
          message: '请选择日志类型',
          required: true,
          trigger: 'change'
        }],
        search: [{
          message: '请输入查询语句',
          required: true,
          trigger: 'blur'
        }],
        period: [{
          message: '请输入统计周期',
          required: true,
          trigger: 'blur'
        }],
        aggregationMethod: [{
          message: '请选择统计方式',
          required: true,
          trigger: 'change'
        }],
        aggregationField: [{
          message: '请输入统计字段',
          required: true,
          trigger: 'blur'
        }],
        condition: [{
          message: '请选择判断条件',
          required: true,
          trigger: 'change'
        }],
        value: [{
          message: '请输入值',
          required: true,
          trigger: 'blur'
        }]
      },
      options: {
        severity: alertSeverities.map(value => {
          return {
            title: this.$t(`alert_severity.${value}`),
            value
          }
        }),
        condition: compareConditions.map(value => {
          return {
            title: this.$t(`compare_condition.${value}`),
            value
          }
        }),
        logType: logTypes.map(value => {
          return {
            title: this.$t(`log_type.${value}`),
            value
          }
        }),
        logAggregationMethod: logAggregationMethods.map(value => {
          return {
            title: this.$t(`log_aggregation_method.${value}`),
            value
          }
        })
      }
    }
  },
  methods: {
    show (id) {
      if (id) {
        this.isUpdate = true
        this.id = id
        getLogTrigger(id)
          .then(res => {
            const data = res.data
            this.form = {
              name: data.name,
              severity: data.severity,
              logType: data.log_type,
              search: data.search,
              period: data.period,
              aggregationMethod: data.aggregation_method,
              aggregationField: data.aggregation_field,
              condition: data.condition,
              value: data.value,
              active: data.active
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            name: this.form.name,
            severity: this.form.severity,
            search: this.form.search,
            period: this.form.period,
            aggregation_method: this.form.aggregationMethod,
            aggregation_field: this.form.aggregationField,
            condition: this.form.condition,
            value: this.form.value,
            active: this.form.active
          }
          if (this.isUpdate) {
            updateLogTrigger(this.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            params.log_type = this.form.logType
            createLogTrigger(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    },
    closeDrawer () {
      this.form = {
        name: '',
        severity: undefined,
        logType: undefined,
        search: '',
        period: 1,
        aggregation_method: undefined,
        aggregation_field: '',
        condition: undefined,
        value: '',
        active: true
      }
      this.$refs.form.resetFields()
      this.visible = false
      this.isUpdate = false
      this.loading = false
    }
  }
}
</script>
